import { useState } from "react";

export enum StorageType {
	LOCAL = "localStorage",
	SESSION = "sessionStorage",
}

function useStorage<T>(key: string, initialValue: T, storageType: StorageType = StorageType.LOCAL) {
	const [storedValue, setStoredValue] = useState<T>(() => {
		try {
			const item =
				storageType === StorageType.LOCAL
					? window.localStorage.getItem(key)
					: window.sessionStorage.getItem(key);
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			return initialValue;
		}
	});
	const setValue = (value: T | ((val: T) => T)) => {
		try {
			const valueToStore = value instanceof Function ? value(storedValue) : value;
			setStoredValue(valueToStore);
			const storageReadyValue = JSON.stringify(valueToStore);
			if (storageType === StorageType.LOCAL) {
				window.localStorage.setItem(key, storageReadyValue);
			} else {
				window.sessionStorage.setItem(key, storageReadyValue);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const deleteValue = () => {
		try {
			if (storageType === StorageType.LOCAL) {
				window.localStorage.removeItem(key);
			} else {
				window.sessionStorage.removeItem(key);
			}
		} catch (error) {
			console.log(error);
		}
	};

	return [storedValue, setValue, deleteValue] as const;
}

export default useStorage;
